import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { Sheet } from 'geniebook-ui/dist';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useStore } from 'jotai';
import GlobalStore from '@store/globalStore';
import {
  forceHideTimedWorksheetPopup,
  showCalculatingSkillLevelInfoPopup,
  showSkillLevelInfoPopup,
} from '@atom/progress';
import SheetWrapper from '@components/misc/SheetWrapper';

type SkillLevelSheetProps = {
  isOpen: boolean;
  handleSheetState: (value: boolean) => void;
};

type MenuItemProps = {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
};

const GradeFilterSheet = (props: SkillLevelSheetProps) => {
  const { isOpen, handleSheetState } = props;
  const store = useStore({ store: GlobalStore });
  const menuItems: MenuItemProps[] = [
    {
      label: 'How to read skill levels?',
      onClick: () => {
        handleSheetState(false);
        showInfoPopup(true);
      },
    },
    {
      label: 'How are my skill levels calculated?',
      onClick: () => {
        handleSheetState(false);
        showCalculatingSkillLevelPopup(true);
      },
    },
    {
      label: 'Browse complete FAQ',
      onClick: () => {
        handleSheetState(false);
        store.set(forceHideTimedWorksheetPopup, false);
        window.open(
          'https://geniebook.atlassian.net/servicedesk/customer/portal/1/topic/28f20a86-57a7-4f0a-898a-30983bf2342a/article/1349058564',
          '_blank',
          'noreferrer',
        );
      },
      icon: <FontAwesomeIcon icon={faUpRightFromSquare as IconProp} />,
    },
  ];

  const handleCloseSheet = () => {
    handleSheetState(false);
    store.set(forceHideTimedWorksheetPopup, false);
  };

  const showInfoPopup = (show: boolean) => {
    store.set(forceHideTimedWorksheetPopup, show);
    store.set(showSkillLevelInfoPopup, show);
  };

  const showCalculatingSkillLevelPopup = (show: boolean) => {
    store.set(forceHideTimedWorksheetPopup, show);
    store.set(showCalculatingSkillLevelInfoPopup, show);
  };

  return (
    <Sheet
      isOpen={isOpen}
      toggleSheet={handleCloseSheet}
      zIndex={102}
      darkMode={false}
      className={
        "px-[20px] font-['Open_Sans'] text-[16px] min-h-[150px] font-semibold text-primary-navyblue exclude-element"
      }
      openHeight={'180px'}
      closeHeight={'180px'}
    >
      <SheetWrapper
        onClickOutside={handleCloseSheet}
        excludeSelector=".exclude-element"
      >
        {menuItems.map((item, index) => (
          <div
            key={item.label}
            className={`text-left py-2 px-2 hover:cursor-pointer ${
              index === 0 ? 'mt-[24px]' : ''
            }`}
            onClick={item.onClick}
          >
            {item.icon && <>{item.icon}&nbsp;&nbsp;</>}
            {item.label}
          </div>
        ))}
      </SheetWrapper>
    </Sheet>
  );
};

export default GradeFilterSheet;
